import React from "react"

import AppointmentList from "../components/patients/appointment/appointment_list"
import AssessmentList from "../components/patients/assessments/assessment_list"

import Phq4 from "../components/patients/assessments/phq4"
import Who5 from "../components/patients/assessments/who5"
import Mtf from "../components/patients/assessments/mtf"
import Providers from "../components/patients/assessments/providers"
import CSQ8 from "../components/patients/assessments/csq8"
import Csi from "../components/patients/enroll/csi"
import CsiRedo from "../components/patients/enroll/csi_redo"
import Tqe from "../components/patients/assessments/tqe"
//import CsiRedoWoLogin from "../components/patients/enroll/csi_redo_wo_login"
import FinalStep from "../components/patients/enroll/final_step"
//import Covid from "../components/patients/assessments/covid"
import CompleteAssessments from "../components/patients/assessments/complete_assessments"

import Sccs from "../components/patients/assessments/sccs"
import Ismi from "../components/patients/assessments/ismi"
import CompleteSelfStigma from "../components/patients/assessments/complete_self_stigma"

import Profile from "../components/public/profile"
import Assessments from "../components/patients/assessments"

import CourseMain from "../components/patients/courses/course_main"
import CourseSession from "../components/patients/courses/course_session"
import CourseLibrary from "../components/patients/courses/course_library"
import CoursePersonas from "../components/patients/courses/course_personas"

import WorksheetList from "../components/patients/worksheets/worksheet_list"
import WorksheetPDF from "../components/patients/worksheets/worksheet_pdf"
import SelfGuideList from "../components/patients/worksheets/self_guide_list"
import SelfGuideDetail from "../components/patients/worksheets/self_guide_detail"
import ResourceDetail from "../components/patients/worksheets/resource_detail"

import HM_module1 from "../components/patients/additional_program/homework_efc/HM_module1"

import AddNotes from "../components/patients/dashboard/add_notes"
import NoteDetails from "../components/patients/appointment/note_details"

const PATIENTS_ROUTES = [
  {   path: "/member/assessment_list",
      key: "assessment_list",
      title: "Assessment List",
      exact: true,
      requireAuth: true,
      component: () => <AssessmentList />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/assessment/phq4/:type/:timepoint",
      key: "phq4",
      title: "PHQ4",
      exact: true,
      requireAuth: true,
      component: () => <Phq4 />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   //path: "/member/assessment/who5/:timepoint",
      path: "/member/assessment/who5/:type/:timepoint",
      key: "who5",
      title: "WHO-5",
      exact: true,
      requireAuth: true,
      component: () => <Who5 />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   //path: "/member/assessment/who5/:timepoint",
      path: "/member/assessment/csq8/:type/:timepoint",
      key: "csq8",
      title: "CSQ8",
      exact: true,
      requireAuth: true,
      component: () => <CSQ8 />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/assessment/providers/:type/:timepoint",
      key: "providers",
      title: "Providers",
      exact: true,
      requireAuth: true,
      component: () => <Providers />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/assessment/csi/:type/:timepoint",
      key: "csi",
      title: "CSI",
      exact: true,
      requireAuth: true,
      component: () => <Csi />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/assessment/csi_redo/:type/:timepoint",
      key: "csi",
      title: "CSI",
      exact: true,
      requireAuth: true,
      component: () => <CsiRedo />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  /*{   path: "/member/assessment/csi_redo_wo/:type/:timepoint/:uid",
      key: "csi",
      title: "CSI",
      exact: true,
      requireAuth: true,
      component: () => <CsiRedoWoLogin />,
      showtitle: 'true',
      ficon: 'fi-home',
  },*/
  {   path: "/member/assessment/final_step/:type/:timepoint",
      key: "final_step",
      title: "Final step",
      exact: true,
      requireAuth: true,
      component: () => <FinalStep />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/assessment/mtf/:type/:timepoint",
      key: "mtf",
      title: "MTF",
      exact: true,
      requireAuth: true,
      component: () => <Mtf />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/assessment/tqe/:type/:timepoint",
      key: "tqe",
      title: "Trackers and Questionnaires Experience ",
      exact: true,
      requireAuth: true,
      component: () => <Tqe />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  /*{   path: "/member/assessment/covid/:type/:timepoint",
      key: "covid",
      title: "COVID",
      exact: true,
      requireAuth: true,
      component: () => <Covid />,
      showtitle: 'true',
      ficon: 'fi-home',
  },*/
  {   path: "/member/assessment/complete_assessments/:type/:timepoint",
      key: "complete_assessments",
      title: "complete_assessments",
      exact: true,
      requireAuth: true,
      component: () => <CompleteAssessments />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/profile",
      key: "profile",
      title: "Profile",
      exact: true,
      requireAuth: true,
      component: () => <Profile />,
      showtitle: 'true',
      ficon: 'fi-bookmark',
  },
  {   path: "/assessments",
      key: "assessments",
      title: "Assessments",
      exact: true,
      requireAuth: true,
      component: () => <Assessments />,
      showtitle: 'true',
      ficon: 'fi-pencil',
  },
  {   path: "/member/appointment_list",
      key: "appointment_list",
      title: "Appointment List",
      exact: true,
      requireAuth: true,
      component: () => <AppointmentList />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/assessment/self_stigma/sccs/:assm_id",
      key: "sccs",
      title: "Self-Concept Clarity Scale",
      exact: true,
      requireAuth: true,
      component: () => <Sccs />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/assessment/self_stigma/ismi/:assm_id",
      key: "ismi",
      title: "Internalized Stigma of Mental Illness Inventory (ISMI)",
      exact: true,
      requireAuth: true,
      component: () => <Ismi />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/assessment/self_stigma/complete/:assm_id",
      key: "complete",
      title: "Complete",
      exact: true,
      requireAuth: true,
      component: () => <CompleteSelfStigma />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/intervention/:cid/main",
      key: "intervention",
      title: "Intervention",
      exact: true,
      requireAuth: true,
      component: () => <CourseMain />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/intervention/:cid/library",
      key: "library",
      title: "Library",
      exact: true,
      requireAuth: true,
      component: () => <CourseLibrary />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/intervention/:cid/personas",
      key: "personas",
      title: "Personas",
      exact: true,
      requireAuth: true,
      component: () => <CoursePersonas />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/intervention/:cid/session/:session/:sub_session/:sub_session_page",
      key: "intervention",
      title: "Intervention",
      exact: true,
      requireAuth: true,
      component: () => <CourseSession />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/worksheets/worksheet_list",
      key: "worksheet_list",
      title: "Worksheets",
      exact: true,
      requireAuth: true,
      component: () => <WorksheetList />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/worksheets/worksheet_pdf/:fid",
      key: "worksheet_pdf",
      title: "Worksheets",
      exact: true,
      requireAuth: true,
      component: () => <WorksheetPDF />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/worksheets/self_guide_list",
      key: "self_guide_list",
      title: "Self-Guided",
      exact: true,
      requireAuth: true,
      component: () => <SelfGuideList />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/worksheets/self_guide_detail/:sg_id",
      key: "self_guide_detail",
      title: "Self-Guided",
      exact: true,
      requireAuth: true,
      component: () => <SelfGuideDetail />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/worksheets/resource_detail/:sg_id",
      key: "resource_detail",
      title: "Resources",
      exact: true,
      requireAuth: true,
      component: () => <ResourceDetail />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/appointment/add_notes/:aid",
      key: "add_notes",
      title: "Add Notes",
      exact: true,
      requireAuth: true,
      component: () => <AddNotes />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/appointment/details/:nid",
      key: "notes_details",
      title: "Notes",
      exact: true,
      requireAuth: true,
      component: () => <NoteDetails />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
  {   path: "/member/additional_program/homework_efc/module1/:day",
      key: "homework_efc_module1",
      title: "Executive Function Coaching Homework",
      exact: true,
      requireAuth: true,
      component: () => <HM_module1 />,
      showtitle: 'true',
      ficon: 'fi-home',
  },
];

export default PATIENTS_ROUTES;
